export default __webpack_public_path__ + "static/media/info.6561e93c.svg";